<template>
  <div>
    <div id="divicw" data-bind="854961AF-3F3B-406A-83C2-D0EA4D9E6340" data-org="" v-if="$i18n.locale === 'en'"></div>
    <div id="divicw" data-bind="007BD0FE-019C-4B5C-8126-824BF45AFAB3" data-org="" v-if="$i18n.locale === 'fr'"></div>
    <footer class="footer" role="contentinfo" v-if="$i18n.locale === 'en'">
      <div class="footer-top vertical-padding clearfix bg-dark">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-md-2 hidden-sm">
              <a href="https://www.ontarionorthland.ca/en" tabindex="-1">
                <span class="sr-only">Ontario Northland</span>
                <picture>
                  <source media="(min-width: 992px)" srcset="../assets/logo-stacked-whitetext.svg">
                  <source media="(max-width: 991px)" srcset="../assets/logo.svg">
                  <img class="img-responsive" src="../assets/logo-stacked-whitetext.svg" alt="">
                </picture>
              </a>
            </div>
            <div class="col-xs-12 col-md-10">
              <div class="region region-footer">
                
                <nav aria-labelledby="aboutThisSite" id="block-ontario-northland-wxt-footer" class="contextual-region" data-block-plugin-id="system_menu_block:footer">
                  
                  <h2 id="aboutThisSite" class="sr-only">About Ontario Northland</h2>
                      
                                          <section class="col-xs-12 col-sm-6">
                        <h3>Company</h3>
                                                  <ul role="menu" class="nav">
                                      <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company" role="menuitem" data-drupal-link-system-path="node/360" tabindex="-1">Company</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company/company-you-keep" role="menuitem" data-drupal-link-system-path="node/321" tabindex="-1">Careers</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company/ontario-northland-news" role="menuitem" data-drupal-link-system-path="node/316" tabindex="-1">News</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company/doing-business-ontc" role="menuitem" data-drupal-link-system-path="node/310" tabindex="-1">Sales and Tenders</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/travel/customer-privacy-policy" role="menuitem" data-drupal-link-system-path="node/329" tabindex="-1">Privacy Policy</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company/infrastructure-projects" role="menuitem" data-drupal-link-system-path="node/369" tabindex="-1">Rail Infrastructure Projects </a>
                                          </li>
                                    </ul>
                      
                                    </section>
                                        <section class="col-xs-12 col-sm-6">
                        <h3>Service</h3>
                                                  <ul role="menu" class="nav">
                                      <li role="presentation">
                        <a href="https://merch.ontarionorthland.ca/" role="menuitem" target="_blank" rel="noopener noreferrer" tabindex="-1">Promotional Item e-Store</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/company/accessibility" role="menuitem" data-drupal-link-system-path="node/359" tabindex="-1">Accessibility</a>
                                          </li>
                                        <li role="presentation">
                        <a href="https://www.ontarionorthland.ca/en/travel/faqs" role="menuitem" data-drupal-link-system-path="node/339" tabindex="-1">FAQ</a>
                                          </li>
                                    </ul>
                      
                                    </section>

                </nav>
                <section id="block-footertextenglish" class="contextual-region block block-block-content block-block-contentcec2daaf-fd52-42db-9452-36399fca3b2f clearfix in-view" data-block-plugin-id="block_content:cec2daaf-fd52-42db-9452-36399fca3b2f">
                  <h2 class="block-title">Contact</h2>
                    <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                      <p>Phone: 1-800-363-7512
                      </p>
                      <p>Email: <a href="mailto:info@ontarionorthland.ca" tabindex="-1">info@ontarionorthland.ca</a>
                      </p>
                      <ul class="list-inline"><li><a href="http://www.youtube.com" target="_blank" rel="noopener noreferrer" tabindex="-1"><span class="fontawesome-icon-inline"><i class="fab fa-youtube"></i></span><span class="sr-only">Youtube</span></a></li>
                        <li><a href="http://www.linkedin.com" target="_blank" rel="noopener noreferrer" tabindex="-1"><span class="fontawesome-icon-inline"><i class="fab fa-linkedin-in"></i></span><span class="sr-only">LinkedIn</span></a></li>
                        <li><a href="http://www.facebook.com" target="_blank" rel="noopener noreferrer" tabindex="-1"><span class="fontawesome-icon-inline"><i class="fab fa-facebook-f"></i></span><span class="sr-only">Facebook</span></a></li>
                        <li><a href="http://www.instagram.com" target="_blank" rel="noopener noreferrer" tabindex="-1"><span class="fontawesome-icon-inline"><i class="fab fa-instagram"></i></span><span class="sr-only">Instagram</span></a></li>
                        <li><a href="http://www.twitter.com" target="_blank" rel="noopener noreferrer" tabindex="-1"><span class="fontawesome-icon-inline"><i class="fa-brands fa-x-twitter"></i></span><span class="sr-only">X (formerly Twitter)</span></a></li>
                      </ul>
                    </div>
                    
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom vertical-padding-sm clearfix">
        <div class="container">
          <div class="row d-flex">
            <div class="col-xs-12 col-sm-8 col-md-9 footer-slogan">
              Ontario Northland is an agency of the government of Ontario
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 footer-ontario-logo">
              <a href="http://www.ontario.ca" target="_blank" rel="noopener noreferrer" tabindex="-1">
                <span class="sr-only">ontario.ca</span>
                <img class="img-responsive" src="../assets/ontario-logo-black.png" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer" role="contentinfo" v-if="$i18n.locale === 'fr'">
      <footer id="wb-info">
      <div class="footer-top vertical-padding clearfix bg-dark">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-md-2 hidden-sm">
              <a href="/fr" title="Ontario Northland">
                <span class="sr-only">Ontario Northland</span>
                <picture>
                  <source media="(min-width: 992px)" srcset="../assets/logo-stacked-whitetext.svg">
                  <source media="(max-width: 991px)" srcset="../assets/logo.svg">
                  <img class="img-responsive" src="../assets/logo-stacked-whitetext.svg" alt="">
                </picture>
              </a>
            </div>
            <div class="col-xs-12 col-md-10">
              
  <div class="region region-footer">
    

<nav aria-labelledby="aboutThisSite" id="block-ontario-northland-wxt-footer" class="contextual-region" data-block-plugin-id="system_menu_block:footer">
  <h2 id="aboutThisSite" class="sr-only">About government</h2>
                          <section class="col-xs-12 col-sm-6">
        <h3>Entreprise</h3>
                                  <ul role="menu" class="nav">
                      <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/entreprise" role="menuitem" data-drupal-link-system-path="node/360">Entreprise</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/entreprise/lentreprise-avec-qui-sengage-long-terme" role="menuitem" data-drupal-link-system-path="node/321">Carrières</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/entreprise/ontario-northland-nouvelles" role="menuitem" data-drupal-link-system-path="node/316">Nouvelles</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/company/faire-affaire-avec-cton" role="menuitem" data-drupal-link-system-path="node/310">Ventes et appels d’offfres</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/voyager/politique-confidentialite-clients" role="menuitem" data-drupal-link-system-path="node/329">Politique de confidentialité</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/entreprise/travaux-dinfrastructure" role="menuitem" data-drupal-link-system-path="node/369">Des travaux d’infrastructure</a>
                          </li>
                    </ul>
      
                    </section>
                        <section class="col-xs-12 col-sm-6">
        <h3>Service</h3>
                                  <ul role="menu" class="nav">
                      <li role="presentation">
        <a href="https://merch.ontarionorthland.ca/" role="menuitem" target="_blank" rel="noopener noreferrer">Cyberboutique d'articles de promotion</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/entreprise/accessibilite" role="menuitem" data-drupal-link-system-path="node/359">Accessibilité</a>
                          </li>
                        <li role="presentation">
        <a href="https://www.ontarionorthland.ca/fr/voyager/faq" role="menuitem" data-drupal-link-system-path="node/339">Foire aux questions</a>
                          </li>
                    </ul>
      
                    </section>
  </nav>


<section id="block-footertextenglish" class="contextual-region block block-block-content block-block-contentcec2daaf-fd52-42db-9452-36399fca3b2f clearfix in-view" data-block-plugin-id="block_content:cec2daaf-fd52-42db-9452-36399fca3b2f">
  
      <h2 class="block-title">Nous joindre</h2>
            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item"><p>Téléphone : 1-800-363-7512
</p>
<p>Courriel : <a href="mailto:info@ontarionorthland.ca">info@ontarionorthland.ca</a>
</p>
<ul class="list-inline"><li><a href="http://www.youtube.com" title="YouTube" target="_blank" rel="noopener noreferrer"><span class="fontawesome-icon-inline"><i class="fab fa-youtube"></i></span><span class="sr-only">Youtube</span></a></li>
  <li><a href="http://www.linkedin.com" title="LinkdIn" target="_blank" rel="noopener noreferrer"><span class="fontawesome-icon-inline"><i class="fab fa-linkedin-in"></i></span><span class="sr-only">LinkedIn</span></a></li>
  <li><a href="http://www.facebook.com" title="Facebook" target="_blank" rel="noopener noreferrer"><span class="fontawesome-icon-inline"><i class="fab fa-facebook-f"></i></span><span class="sr-only">Facebook</span></a></li>
  <li><a href="http://www.instagram.com" title="Instagram" target="_blank" rel="noopener noreferrer"><span class="fontawesome-icon-inline"><i class="fab fa-instagram"></i></span><span class="sr-only">Instagram</span></a></li>
  <li><a href="http://www.twitter.com" title="X (formally twitter)" target="_blank" rel="noopener noreferrer"><span class="fontawesome-icon-inline"><i class="fa-brands fa-x-twitter"></i></span><span class="sr-only">X (formerly Twitter)</span></a></li>
</ul></div>
  </section>
  </div>


            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom vertical-padding-sm clearfix">
        <div class="container">
          <div class="row d-flex">
            <div class="col-xs-12 col-sm-8 col-md-9 footer-slogan">
              Ontario Northland est une agence du gouvernement de l'Ontario
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 footer-ontario-logo">
              <a href="http://www.ontario.ca" title="ontario.ca" target="_blank" rel="noopener noreferrer">
                <span class="sr-only">ontario.ca</span>
                <img class="img-responsive" src="../assets/ontario-logo-black.png" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      langs: ["en", "fr"]
    };
  },
  computed: {},
  watch: {},
  mounted() {}
};
</script>
<style lang="scss">
//== Media queries breakpoints
//
//## Define the breakpoints at which your layout will change, adapting to different screen sizes.

// Extra small screen / phone
//** Deprecated `$screen-xs` as of v3.0.1
$screen-xs: 480px !default;
//** Deprecated `$screen-xs-min` as of v3.2.0
$screen-xs-min: $screen-xs !default;
//** Deprecated `$screen-phone` as of v3.0.1
$screen-phone: $screen-xs-min !default;

// Small screen / tablet
//** Deprecated `$screen-sm` as of v3.0.1
$screen-sm: 768px !default;
$screen-sm-min: $screen-sm !default;
//** Deprecated `$screen-tablet` as of v3.0.1
$screen-tablet: $screen-sm-min !default;

// Medium screen / desktop
//** Deprecated `$screen-md` as of v3.0.1
$screen-md: 992px !default;
$screen-md-min: $screen-md !default;
//** Deprecated `$screen-desktop` as of v3.0.1
$screen-desktop: $screen-md-min !default;

// Large screen / wide desktop
//** Deprecated `$screen-lg` as of v3.0.1
$screen-lg: 1200px !default;
$screen-lg-min: $screen-lg !default;
//** Deprecated `$screen-lg-desktop` as of v3.0.1
$screen-lg-desktop: $screen-lg-min !default;

// So media queries don't overlap when required, provide a maximum
$screen-xs-max: ($screen-sm-min - 1) !default;
$screen-sm-max: ($screen-md-min - 1) !default;
$screen-md-max: ($screen-lg-min - 1) !default;

.footer {
  margin-top: 100px;
  background: #333;
  padding: 16px 0 16px;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    color:#fff;
    li{
          margin-bottom: 0.75em;
    }
  }
  .region-footer {
    //padding-left: 60px;
  }
}
  .footer-bottom{
    background-color:#fff;
    padding:20px 0px;
    .footer-slogan{
      align-items: center;
      display: flex;
    }
    img{
          max-height: 40px;
    }
  }
.footer{
  h2.block-title, h3 {
    color:$white;
    font-size: 20px;
    margin: 0 0 10px;
    text-transform: none;
    font-weight: 400;
  }
  .footer-top{
    color: $white;
    padding-bottom: 40px;
    padding-top: 40px;

    .region-footer{
      display: flex;
      flex-wrap: wrap;

      #block-ontario-northland-wxt-footer{
        flex-grow: 1;
      }

      .block-title{
        
      }

      .field{
        a{
          color:$white;
          &:visited{
            color: $white;
          }

          &:hover,
          &:focus{
            color: $brand-secondary;
          }
        }
      }

      @media screen and (min-width: $screen-md-min){
        padding-left: $padding-large;
      }

      @media screen and (max-width: $screen-xs-max) {
        //text-align: center;

        .block{
          width: 100%;
        }
      }
      
    }
  }

  h3,
  h2.block-title{
    font-size: $font-size-h5;
    margin: 0 0 10px;
    text-transform: none;

    @media screen and (max-width: $screen-xs-max) {
      font-size: $font-size-h4;
      margin-top: $padding-xs;
      text-decoration: underline;
    }
  }

  ul.nav{
    margin-bottom: 0;

    li{
      margin-bottom: 0;

      a{
        background: none!important;
        padding: 5px 0;
        color:$white;
        
        &:visited{
          color: $white;
        }

        &:hover,
        &:focus,
        &.is-active{
          color: $brand-secondary;
        }

      }
    }
  }

  .footer-bottom{
    .footer-slogan{
      @media screen and (min-width: $screen-sm-min){
        align-items: center;
        display: flex;
      }
    }

    .footer-ontario-logo{
      img{
        max-height: 40px;
      }

      @media screen and (min-width: $screen-sm-min) and (max-width: $screen-sm-max){
        text-align: right;
      }
    }

    @media screen and (max-width: $screen-xs-max){
      text-align: center;

      img{
        margin: 10px auto 0;
      }
    }
  }
}
.d-flex {
    display: flex;
    flex-wrap: wrap;
}
@media screen and (max-width:767px){
  footer .footer-top img {
            margin: 0 auto 15px auto;
            max-width: 280px;
        }
}
@media screen and (min-width: 768px) {
  .colcount-sm-2 {
        -webkit-column-count: 2;
        column-count: 2
  }
}
@media screen and (min-width: 992px) {
  .colcount-md-3 {
      -webkit-column-count: 3;
      column-count: 3
  }
}

.vertical-padding-lg {
    padding-bottom: 60px;
    padding-top: 60px;
}

</style>
